import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './registerServiceWorker';
import App from './App';

// The production build prints nothing through console.log: many log lines print the signed-in user (with its session tokens), shop credentials or one-time codes
if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
}

ReactDOM.render(<App />, document.getElementById('app'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();